import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../../components/PageConfigProvider/constants';
import type { TabContent } from '../../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../../components/PageConfigProvider/types';
import { FilterId } from '../../filters/types/filters';

const items: TabContent['items'] = [
  {
    id: 'geography-screener-v2-table',
    title: 'Discovery',
    position: {
      x: 0,
      y: 0,
      width: DEFAULT_GRID_COLUMNS,
      height: DEFAULT_GRID_ROWS,
    },
    plot: {
      chartType: 'table',
      defaultMetricOptions: ['screener_headcount'],
      showZebraStripe: true,
    },
  },
];

const geographyScreenerTab: TabContent = {
  id: 'geography-screener-v2',
  items,
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.GEOGRAPHY,
    FilterId.CONTINGENT_WORKERS,
    FilterId.MULTI_ATTRITION_RATE,
    FilterId.MULTI_GROWTH_RATE,
    FilterId.MULTI_HIRING_RATE,
    FilterId.MULTI_HEADCOUNT,
    FilterId.MULTI_INFLOW,
    FilterId.MULTI_OUTFLOW,
    FilterId.MULTI_SALARY,
    FilterId.MULTI_TENURE,
    // Note: Geography filter is now a secondary filter (FilterId.GEOGRAPHY) instead of primary filter
    // Note: segmentable filters above can be broken down via the segment
    // selector, which offers exactly: Ethnicity, Gender, Geography,
    // Highest Degree, Industry, Role, Seniority (see SegmentSelector.tsx).
    // Company is NOT among them and there is no company filter on this page,
    // so geography results cannot be scoped to a named employer here.
  ].map((id) => ({ id })),
};

export const geographyScreener: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.GEOGRAPHY_SCREENER,
  revelioPageId: RevelioPageId.GEOGRAPHY_SCREENER,
  name: 'Discovery',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'geography-screener-v2',
      label: 'Discovery',
      tabContent: geographyScreenerTab,
      isActive: true,
    },
  ],
};
